/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=7f823e74&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=7f823e74&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=7f823e74&scoped=true&lang=css"

import exportComponent from "/home/nightdays/app/code/vue/nb-recharge/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f823e74"]])

export default __exports__